module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isPlaceholder.js
// module id = 96
// module chunks = 0